/**
 * Main Menu object
 */
var Breadcrumb = {

	init : function() {

        this.breadcrumbWrapper = $(".breadcrumb");
        this.breadcrumb = this.breadcrumbWrapper.find("li");

        var that = this;

        // Add color to items
        var colorItem = $(this.breadcrumbWrapper).data('color');
        Breadcrumb._addColor($(this.breadcrumbWrapper), colorItem);
	},

  /*** Functions ****/
  _addColor : function(item, colorItem) {
    item.css("color", colorItem);
  }

}

$(document).ready(function() {
    Breadcrumb.init();
});
